export default {
    init: function (utils) {
        this.initProductRemove();
        this.initFirstEditScroll();
    },

    initProductRemove: function () {
        const productRemoveBtnAll = document.querySelectorAll('.js-product-remove-btn');
        productRemoveBtnAll.forEach((productRemoveBtn) => {
            productRemoveBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const productRemove = productRemoveBtn.closest('.js-product-remove')
                if(productRemove){
                    console.log(productRemove.dataset);
                    const salonId = productRemove.dataset.salonId;
                    const productId = productRemove.dataset.productId;
                    if(confirm('Voulez-vous vraiment supprimer ce produit ?')) {
                        this.deleteProduct(salonId, productId, productRemoveBtn);
                    }
                }
            });
        });
    },

    deleteProduct: function (salonId, productId, productRemoveBtn) {
        let productCard = productRemoveBtn.closest('.js-product-card'); 
        productCard.classList.add('--removing');
        fetch(wordpress_vars.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                action: 'delete_product_portal',
                salon_id: salonId,
                product_id: productId,
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                productCard.classList.add('--removing');
                window.location.href = window.location.href;
                setTimeout(() => {
                    productRemoveBtn.remove();
                }, 500);
                document.querySelector('.js-notification-delete-member').classList.remove('--hidden');
                setTimeout(() => {
                    productCard.remove();
                    document.querySelector('.js-notification-delete-member').classList.add('--hidden');
                }, 3000);
            } else {
                console.error('Erreur lors de la mise à jour', data);
            }
        });
    },

    /**
     * Auto scroll sur la page d'édition produit si le paramètre GET "first_edit" est présent.
     * On scroll jusqu'au titre de l'étape 2 avec un offset de 20px pour éviter d'être collé au bord.
     */
    initFirstEditScroll: function () {
        const params = new URLSearchParams(window.location.search);
        if (!params.has('first_edit')) return;

        const target = document.querySelector('.js-portal-product-step-2-title');
        if (!target) return;

        const doScroll = () => {
            const rect = target.getBoundingClientRect();
            const absoluteTop = window.scrollY + rect.top;
            const offset = 20; // A bit more space above
            const top = Math.max(absoluteTop - offset, 0);
            window.scrollTo({ top, behavior: 'smooth' });
        };

        // Attendre un tick pour s'assurer que le layout est prêt (images, blocs chargés)
        if (document.readyState === 'complete') {
            setTimeout(doScroll, 100);
        } else {
            window.addEventListener('load', () => setTimeout(doScroll, 100), { once: true });
        }
    }
}